import { Provider, type createStore } from 'jotai';
import { allDatasetAtoms } from 'pages/map-query/atoms';
import { datasetRegistry } from 'pages/map-query/datasets';
import { DatasetProvider } from 'pages/map-query/dataset-context';
import { DynamicTileLayer } from 'pages/map-query/map-section/dynamic-tile-layer';
import { SubsurfaceCellsLayer } from 'pages/map-query/subsurface-maps/cells-layer';

type JotaiStore = ReturnType<typeof createStore>;

// Wells already draw on this map, coloured by the rail; these are the rest.
const LAYER_DATASET_IDS = ['documents', 'subsurfaceMaps'];

/**
 * Map Query's Documents and Petrotech Maps layers on the area's map, bounded by
 * the area as their tables are, so a row's "Show on map" has a shape to mark and a
 * Petrotech map's raster has somewhere to draw. Mount inside `<Map>`.
 *
 * @param {object} props - The area's dataset store.
 * @param {JotaiStore} props.store - From `useAreaDatasetStore`.
 * @return {JSX.Element} The layers.
 */
export function AreaDatasetMapLayers({
  store,
}: {
  store: JotaiStore;
}): JSX.Element {
  return (
    <Provider store={store}>
      {LAYER_DATASET_IDS.map((id) => (
        <DatasetProvider
          key={id}
          config={datasetRegistry[id]}
          atoms={allDatasetAtoms[id]}
        >
          <DynamicTileLayer />
        </DatasetProvider>
      ))}
      <SubsurfaceCellsLayer />
    </Provider>
  );
}
